import React from "react";
import ModalUI from "../ui/ModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import RichTextEditor from "../texts/RichTextEditor";
import CustomButton from "../CustomButton";


function AddUpdateTemplateModalUI({
  show,
  handleClose,
  title,
  values,
  handleChange,
  handleSubmit,
  isSubmitting,
  errors,
  touched,
  setFieldValue, 
  isEdit = false,
}) {
  return (
    <ModalUI show={show} handleClose={handleClose} title={title} centerd={true}> 
      <form onSubmit={handleSubmit}>
        <ShortTextInput
          label="Title"
          type="text"
          id="title"
          name="title"
          required
          value={values.title}
          onChange={handleChange}
          placeholder="Enter template title"
          className="form-control"
          error={touched.title && errors.title ? errors.title : ""}
        />
        
        <RichTextEditor
          label="Description"
          id="description"
          placeholder="Enter Risk description..."
          required
          editorValue={values.description}
          setEditorValue={(value) => setFieldValue("description", value)}
          error={touched.description && errors.description ? errors.description : ""}
        />

        <div className="d-flex justify-content-center gap-2 mt-4">
          <CustomButton type="submit" disabled={isSubmitting}>
            {isSubmitting? "Saving...": isEdit ? "Update Template": "Add Template"}
          </CustomButton>
        </div>
      </form>
    </ModalUI>
  );
}

export default AddUpdateTemplateModalUI;
